import { FormControl, InputLabel, MenuItem, Select, Tab, Tabs } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FAQ_CATEGORIES } from '../constants';
import { FAQ_PAGE_LABELS as LABELS } from '../../../utils/labels';
import type { FaqCategoryKey } from '../types';

interface FaqCategoryFilterProps {
  value: FaqCategoryKey;
  onChange: (value: FaqCategoryKey) => void;
}

export default function FaqCategoryFilter({ value, onChange }: FaqCategoryFilterProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <FormControl fullWidth size="small">
        <InputLabel>{LABELS.categoryFilterLabel}</InputLabel>
        <Select
          label={LABELS.categoryFilterLabel}
          value={value}
          onChange={(e) => onChange(e.target.value as FaqCategoryKey)}
          inputProps={{ 'aria-label': LABELS.categoryFilterLabel }}
          data-testid="faq-category-select"
        >
          {FAQ_CATEGORIES.map((c) => (
            <MenuItem key={c.key} value={c.key} data-testid={`option-${c.key}`}>
              {c.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <aside className="w-56 shrink-0 border-r border-border">
      <Tabs
        orientation="vertical"
        value={value}
        onChange={(_, v) => onChange(v)}
        aria-label={LABELS.categoryFilterLabel}
      >
        {FAQ_CATEGORIES.map((c) => (
          <Tab key={c.key} value={c.key} label={c.label} className="normal-case items-start text-start text-base" />
        ))}
      </Tabs>
    </aside>
  );
}
